var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#460a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "461b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#461b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D4112A",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#20BD42",
    fillRule: "evenodd",
    d: "M0 11.734h22v4.267H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02A3BD",
    fillRule: "evenodd",
    d: "M0 0h22v4.267H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 5.333h22v5.333H0zm5.238-1.157a1.6 1.6 0 0 1-.524.09c-.867 0-1.571-.716-1.571-1.6 0-.883.704-1.6 1.571-1.6q.277.001.524.091a1.6 1.6 0 0 0-1.048 1.51c0 .696.437 1.29 1.048 1.509",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#78CDDB",
    fillRule: "evenodd",
    d: "M6.286 2.133h1.047V3.2H6.286zm1.047-1.067h1.048v1.067H7.333zm1.048 1.067h1.047V3.2H8.381zm1.047-1.067h1.048v1.067H9.428zm1.048 1.067h1.048V3.2h-1.048zM9.428 3.2h1.048v1.066H9.428zm-2.095 0h1.048v1.066H7.333z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "460a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagUz = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagUz);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";